export default "__VITE_ASSET__DeySr9Sn__";